interface ResizeImageConfig {
  maxWidth?: number
  maxHeight?: number
}

export const resizeImage = async (
  file: File,
  { maxHeight = 200, maxWidth = 200 }: ResizeImageConfig = {}
): Promise<string | undefined> => {
  if (!file) return undefined
  return new Promise((res) => {
    const reader = new FileReader()
    // Set the image once loaded into file reader
    let imageURL: string
    reader.onload = (e) => {
      const img = document.createElement('img')
      img.onload = () => {
        const canvas = document.createElement('canvas')
        let ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0)

        const MAX_WIDTH = maxWidth
        const MAX_HEIGHT = maxHeight
        let width = img.width
        let height = img.height

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width
            width = MAX_WIDTH
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height
            height = MAX_HEIGHT
          }
        }
        canvas.width = width
        canvas.height = height
        ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0, width, height)

        imageURL = canvas.toDataURL(file.type)
        res(imageURL)
      }
      img.src = (e.target as any).result
    }
    reader.readAsDataURL(file)
  })
}
